module.exports = __webpack_public_path__ + "static/media/mining.ac3a10c2.jpg";